<template>
    <div class="pg-answer-site"
      ref="home"
      :class="{'with-bg': baseStyle && (baseStyle.bgSrc || baseStyle.color)}"
      :style="style"
      v-loading.fullscreen.lock="isLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="container"
            :style="{background: baseStyle && (baseStyle.bgSrc || baseStyle.color) && baseStyle.opacity >= 0 ? 'rgba(255, 255, 255, ' + baseStyle.opacity/100 + ')' : '#fff'}">
            <img :src="baseStyle.header" class="header_img" width="100%" v-if="baseStyle && baseStyle.header">
            <div class="progress" :class="{fixed: invisible}">
                <div class="progress-bar s-prog-wait" ref="progress">
                    <div class="progress-done s-prog-done" :style="{width: width + '%'}"></div>
                </div>
            </div>
            <div class="survey_cover_text">
                <div class="TopBgTitle">
                    <p>{{base.title}}</p>
                </div>
                <div class="desc_begin" v-html="base.desc"></div>
                <!-- <div class="wjhr"></div> -->
                <div class="user" v-if="base.logintype == 1 && account">
                    <span class="username">欢迎您，{{account}}</span>
                    <i class="el-icon-switch-button" @click="logout"></i>
                </div>
            </div>
            <div class="questions">
                <QuestionSite
                    :data="item"
                    v-on:itemClick="itemOnClick"
                    v-on:contentUpdate="contentOnUpdate"
                    v-on:itemContentUpdate="itemContentUpdate"
                    v-for="(item, index) in questions"
                    :textColor="style.color || ''"
                    :optionColor="baseStyle.optionColor"
                    :optionHighlightColor="baseStyle.optionHighlightColor"
                    :key="item.qid"
                    :sort="index + 1"
                    :isEn="isEOZ"
                ></QuestionSite>
            </div>
            <div class="submmit" @click="submit()">{{ isEOZ ? 'Submit' : '提交' }}</div>
            <!-- <div class="submmit">提交</div> -->
            <div class="tail"></div>
        </div>
        <!-- <Login v-if="showLogin"></Login> -->
    </div>
</template>
<script>
  import Vue from 'vue';
//   import Login from '~/components/LoginSite/login.vue';
  import QuestionSite from '~/components/QuestionSite/question.vue';
  import api from '~/siteApi/api';
  import { getParameterByName, getUrlParams, redirectTo } from '~/tools/utils';
  import ElementUI from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css';
  import DeviceDetector from "device-detector-js";
  import { isMobile } from '~/tools/utils';
//   import 'amfe-flexible';

  Vue.use(ElementUI);

  export default {
    components: {
        QuestionSite
    },
    data () {
        return {
          isLoading: false,
          activeRecord: [], // 规则命中记录
          invisible: false,
          isInIFrame: getParameterByName('iframe'),
          questions: null,
          base: {

          },
          baseStyle: {},
          style: {},
          account: '',
          glogin: null,
          showLogin: false,
          starttime: null,
          isEOZ: false
        }
    },
    computed: {
        width() {
            let val = this.finished*100/this.questionNum;
            return val
        },
        questionNum() {
            return this.questions ? this.questions.length : 1
        },
        finished() {
          let finishedAccount = 0;
          if(!this.questions) return 0
          for (let index = 0; index < this.questions.length; index++) {
              const element = this.questions[index];
              if(/^[1|4|5]/.test(element.qtype)) {
                  let matchedIndex = element.options.findIndex(item => item.selected);
                  // remark为包含填空
                  if(matchedIndex >= 0 && (element.options[matchedIndex].remark != 1 || (element.options[matchedIndex].remark == 1 &&
                    (element.options[matchedIndex].content_required != 1 || (element.options[matchedIndex].content_required == 1 && element.options[matchedIndex].text))
                  ))) {
                    finishedAccount++;
                  }
              } else if(/^2/.test(element.qtype)) {
                let matchedItems = element.options.filter(item => item.selected);
                if(matchedItems.length && matchedItems.every(x => x.remark != 1 || (x.remark == 1 && (x.content_required != 1 || (x.content_required == 1 && x.text)) ))) {
                    finishedAccount++;
                }
              } else if(/^6/.test(element.qtype)) {
                if(element.rows.every(x => x.val >= 0)) {
                    finishedAccount++;
                }
              } else if(element.content) {
                  finishedAccount++;
              }
          }
          return finishedAccount
        }
    },
    mounted() {
        if(isMobile()) {
            location.replace(location.href.replace(/\/site\//, "/"))
        }
        window.addEventListener('message', event => {
            // console.log('postMessage' + JSON.stringify(event.data));
            if(event.data == 'refresh') {
                this.init();
            }
        });
        Promise.all([
          this.unComplete('first'),
          this.init(),
          this.initLogin()
        ]).then(() => {
          if(this.base.logintype == 1 && !this.account) {
            this.glogin && this.glogin.login();
          }
          if(this.base.tags && this.base.tags.split(',').includes('EOZ')) {
            this.isEOZ = true;
            // 在head结束标签前插入下面的FB代码
            let script = document.createElement('script');
            script.text = `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '207592768792213');
              fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
            let noscript = document.createElement('noscript');
            noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=207592768792213&ev=PageView&noscript=1" />`;
            document.head.appendChild(noscript);
          } else {
            // 设置页面标题
            document.title = '调查问卷';
          }
        })

        window.addEventListener('scroll', () => {
          let scroll = this.getScroll();
          if(scroll.y >= 109) {
            this.invisible = true
          } else {
            this.invisible = false
          }
        });
    },
    // watch: {
    //   glogin(val) {
    //     if(this.base.logintype == 1 && !this.account) {
    //       val.login();
    //     }
    //   }
    // },
    methods: {
      showAlert(msg) {
        return this.$alert(msg, this.isEOZ ? 'Notice' : '提示', {
          confirmButtonText: this.isEOZ ? 'OK' : '确定'
        });
      },
      unComplete(tag) {
        // 请求接口数据，打开页面就请求一次
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(window.navigator.userAgent);
        if(device.device && device.device.model === 'LIO-AN00') {
          device.device.model = 'Mate 30 Pro(5G)'
        }
        let baseUrl = process.env.VUE_APP_ENV == 'development' ? '/surveyapi' : process.env.VUE_APP_ENV == 'pre' ? '//gapi.dev.ztgame.com/surveyapi' : '//gapi.ztgame.com/surveyapi'
        fetch(`${baseUrl}/f/user/reply`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sid: this.$route.params.sid,
            starttime: tag ? '' : this.starttime,
            clientinfo: JSON.stringify(device),
            reply_status: -1
          }),
          keepalive: true // 保持连接
        })
      },
      initLogin() {
        return new Promise((resolve) => {
          let _this = this;
          if(!this.isInIFrame && process.env.VUE_APP_ENV !== 'development') {
            requirejs(['login/index'], gLogin => {
              _this.glogin = new gLogin({
                  type:'popup',
                  //设置 去注册按钮
                  fastreg:{
                      //注意：不支持回调函数
                      type: 'normal'
                  },
                  login_type: 27,
                  onLogin: function(result) {
                      if(result){
                          //登录成功
                          api.login({
                              sid: _this.$route.params.sid
                          }).then(res => {
                              if(!res) return;
                              _this.account = res.data.account;
                              if(res.replycount == 1) {
                                  _this.showAlert(_this.isEOZ ? 'You have already completed this survey. Thank you for participating.' : '您已参加过该问卷调查哦，感谢您的参与~');
                              }
                          });
                      } else{
                          //登录失败
                          _this.showAlert(result.msg);
                      }
                  },
                  onLogout:function(result){
                      if(!!result&&!!result.status&&result.status>0){
                          //注销成功
                      }
                      else{
                          //注销失败
                          _this.showAlert(result.msg);
                      }
                  }
              });
              resolve();
            });
          } else {
            resolve();
          }
        })
      },
      getScroll() {
          if (window.pageXOffset) {
              return {//主流浏览器 ie9及以上
                  x: window.pageXOffset,
                  y: window.pageYOffset
              }
          } else { //ie8及以下
              return {
                  x: document.documentElement.scrollLeft,
                  y: document.documentElement.scrollTop
              }
          }
      },
      shuffle(arr) {
        var len = arr.length;
        for(var i=0;i<len;i++){
            var end = len - 1 ;
            var index = (Math.random()*(end + 1)) >> 0;
            var t = arr[end];
            arr[end] = arr[index];
            arr[index] = t;
        }
        return arr;
      },
      logout() {
          this.$confirm('确认要登出吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return api.logout(this.$route.params.sid)
          }).then(res => {
              if(!res) return;
              this.account = '';
              if(!this.isInIFrame && this.base.logintype == 1) {
                  this.glogin.login();
              }
          });
      },
      async init() {
        let _this = this;
        try {
          let res = await api.getInfo(this.$route.params.sid);
          if(!res) return;
          // 去掉问卷乱序随机
          // if(res.data.unorder == 1) {
          //   _this.questionsAll = _this.shuffle(JSON.parse(JSON.stringify(res.question)));
          // }
          _this.questionsAll = JSON.parse(JSON.stringify(res.question));
          // 去掉选项随机逻辑
          // if(_this.questionsAll) {
          //   _this.questionsAll = _this.questionsAll.map(x => {
          //     if(x.qtype == 2 && x.unorder == 1) {
          //       x.options = _this.shuffle(JSON.parse(JSON.stringify(x.options)));
          //     }
          //     return x;
          //   });
          // }
          res.data.desc = res.data.desc.replace(/\n/g, "<br/>")
          _this.base = Object.assign({}, res.data);
          _this.baseStyle = Object.assign({}, res.data.style);
          if(_this.base.tags && _this.base.tags.split(',').includes('EOZ')) {
            _this.isEOZ = true;
          }
          if(_this.isEOZ) {
            _this.questionsAll && _this.questionsAll.forEach(q => {
              if(q.options) {
                q.options.forEach(opt => {
                  if(opt.content === '其他') {
                    opt.content = 'Other';
                  }
                });
              }
            });
          }
          _this.oldLogics = res.logics;
          _this.logics = res.logicsv2;
          if(res.logics.length && !res.logicsv2.length) {
            _this.showAlert(_this.isEOZ ? 'This survey configuration has expired. Please contact the administrator.' : '该问卷配置已过期，请联系管理员~');
          } else if(_this.logics && _this.logics.length) {
            // 初始化把逻辑的目标问题隐藏
            _this.questionsAll && _this.questionsAll.map(x => {
              if(_this.logics.some(logic => logic.target_qid === x.qid && logic.rule === 'show')) {
                x.hide = true
              }
              return x;
            })
          }

          let style = _this.baseStyle;
          delete _this.style.backgroundImage;
          delete _this.style.backgroundColor;

          if (style) {
            if (style.bgSrc) {
              _this.style = Object.assign({}, {
                backgroundImage: `url(${style.bgSrc})`,
                backgroundSize: 'cover'
              });
            } else if (style.color) {
              _this.style = Object.assign({}, {
                backgroundColor: style.color
              });
            }
            if (style.textColor) {
              _this.style = Object.assign({}, _this.style, {
                color: style.textColor
              });
            } else {
              _this.style.color = '#484848';
            }
            this.$refs.home.style.width = style.width + 'px';

            _this.questions = JSON.parse(JSON.stringify(_this.questionsAll)).filter(q => !q.hide);
          }
          if(res.user) {
              _this.account = res.user.account;
              _this.starttime = res.user.starttime;
          }
          if(!_this.isInIFrame && (_this.base.logintype == 2 || _this.base.logintype == 5) ) {
              let params = getUrlParams();
              return api.login(Object.assign(params, {
                sid: this.$route.params.sid
              })).then(res => {
                if(!res) return;
                _this.account = res.data.account;
                if (res.errors && res.errors.error_message) {
                    _this.showAlert(res.errors.error_message[0]);
                    return;
                }
                if(res.replycount == 1) {
                    _this.showAlert(_this.isEOZ ? 'You have already completed this survey. Thank you for participating.' : '您已参加过该问卷调查哦，感谢您的参与~');
                }
              });
          }
        } catch (error) {
          console.log(error);
        }
      },
      itemContentUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.text = indexData.text;
                }
                return item;
              });
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item) => {
              item.text = indexData.text;
              return item;
            });
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      checkItemSelect(element){
        if(/^[1|4|5]/.test(element.qtype)) {
            let matchedIndex = element.options.findIndex(item => item.selected);
            // remark为包含填空
            if(!(matchedIndex >= 0 && (element.options[matchedIndex].remark != 1 || (element.options[matchedIndex].remark == 1 &&
              (element.options[matchedIndex].content_required != 1 || (element.options[matchedIndex].content_required == 1 && element.options[matchedIndex].text))
            ))) ){
              this.unComplete();
            }
        } else if(/^2/.test(element.qtype)) {
          let matchedItems = element.options.filter(item => item.selected);
          if(!(matchedItems.length && matchedItems.every(x => x.remark != 1 || (x.remark == 1 && 
          (x.content_required != 1 || (x.content_required == 1 && x.text)) )))) {
            this.unComplete();
          }
        } else if(/^6/.test(element.qtype)) {
          if(!(element.rows.every(x => x.val >= 0))) {
            this.unComplete();
          }
        } else if(!element.content) {
            this.unComplete();
        }
      },
      itemOnClick(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.checkItemSelect(questionData);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              let currentState = questionData.options.find((item, index) => index == indexData.index).selected;
              // 先解决互斥选项
              if(!currentState) { // 由未选中变为选中
                let currentExclusion = questionData.options[indexData.index].is_exclusion
                questionData.options = questionData.options.map(item => {
                  if(currentExclusion === "1") {
                    item.selected = false;
                  } else { // 非互斥项，把互斥项的选中状态置为false
                    if(item.is_exclusion === "1") {
                      item.selected = false;
                    }
                  }
                  return item;
                });
                questionData.options.forEach((item, index) => {
                  if(currentExclusion === "1" && indexData.index != index) {
                    this.resetQuestions(questionData, index);
                  } else if(item.is_exclusion === "1") { // 非互斥项，把互斥项的选中状态置为false
                    this.resetQuestions(questionData, index);
                  }
                  return item;
                });
              }
              let selectedNum = questionData.options.filter(item => item.selected).length;
              if(!currentState && selectedNum === parseInt(questionData.maxnum)) {
                this.showAlert(this.isEOZ ? `Select up to ${questionData.maxnum} options for this question.` : `该题请至多选择${questionData.maxnum}项哦~`);
                return;
              }
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                  item.selected = !item.selected;
                }
                return item;
              });
              this.resetQuestions(questionData, indexData.index);
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item, index) => {
              item.selected = index == indexData.index ? true : false;
              return item;
            });
            questionData.options.forEach((item, index) => {
              this.resetQuestions(questionData, index);
            })
          } else if(indexData.qtype == 6) {
            // 矩阵题
            questionData.rows[indexData.dIndex].val = indexData.index;
            questionData.options.forEach((item, index) => {
              this.resetQuestions(questionData, index, indexData.dIndex);
            })
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      contentOnUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          questionData.content = indexData.content;
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      reCursiveHide(matchedIndex) {
        let src = this.questionsAll[matchedIndex];
        let qIndex = this.questions.findIndex(item => item.qid == src.qid);
        if(qIndex < 0) {
          return;
        }
        if(src.qtype == 6) {
          src.rows.map(item => {
            item.val = -1;
            return item;
          })
          src.rows.forEach((item, index) => {
            this.resetQuestions(src, 0, index);
          })
        } else if (/^[1|2|4|5]/.test(src.qtype)) {
          src.options.map(item => {
            item.selected = false;
            return item;
          })
          src.options.forEach((item, index) => {
            this.resetQuestions(src, index);
          })
        } else {
          src.content = ''
        }
      },
      resetQuestions(src, index, rowIndex) {
        let _this = this;
        this.logics.map(logic => {
          logic.conditions.map(condition => {
            if(src.qtype == 6) { // 矩阵题
              if(condition.qid == src.qid && src.rows[rowIndex].rid == condition.rid) {
                if(src.rows[rowIndex].val >= 0 && condition.oids.includes(src.options[src.rows[rowIndex].val].oid)) {
                  condition.active = true;
                } else {
                  condition.active = false;
                }
              }
            } else {
              if(condition.qid == src.qid) {
                let checkedOptions = src.options.filter(item => item.selected);
                condition.active = checkedOptions.some(item => condition.oids.includes(item.oid));
              }
            }
            return condition;
          })
          if(logic.condition_type === 'and') {
            logic.active = logic.conditions.every(condition => condition.active);
          } else if(logic.condition_type === 'or') {
            logic.active = logic.conditions.some(condition => condition.active);
          }
          let matchedIndex = _this.questionsAll.findIndex(q => q.qid == logic.target_qid);
          if(matchedIndex >= 0) {
            let prviousValue = _this.questionsAll[matchedIndex].hide;
            if(logic.rule === 'show') {
              _this.questionsAll[matchedIndex].hide = !logic.active;
            } else if(logic.rule === 'hide') {
              _this.questionsAll[matchedIndex].hide = logic.active;
            }
            if(!prviousValue && _this.questionsAll[matchedIndex].hide) {
              _this.reCursiveHide(matchedIndex)
            }
            _this.questions = JSON.parse(JSON.stringify(_this.questionsAll)).filter(q => !q.hide);
          }
          return logic;
        });
      },
      checkForm() {
        for (let index = 0; index < this.questions.length; index++) {
          const element = this.questions[index];
          if(/^[1|4|5]/.test(element.qtype)) {
              let matchedIndex = element.options.findIndex(item => item.selected);
              if(element.required == 1) {
                  if(matchedIndex == -1) {
                      this.showAlert(this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`);
                      return false;
                  }
                  // 其他项必填且未填时，校验失败
                  if(element.options[matchedIndex].remark == 1 &&
                    element.options[matchedIndex].content_required == 1 &&
                    !element.options[matchedIndex].text
                  ) {
                      this.showAlert(this.isEOZ ? `Please complete item ${matchedIndex + 1} in Question ${index + 1}.` : `请填写第${index + 1}题的第${matchedIndex + 1}个选项哦~`);
                      return false;
                  }
              }
          } else if(/^2/.test(element.qtype)) {
              let matchedItems = element.options.filter(item => item.selected);
              if(element.required == 1) {
                  if(!matchedItems.length) {
                      this.showAlert(this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`);
                      return false;
                  }
                  if(!matchedItems[0].is_exclusion && matchedItems.length < parseInt(element.minnum)) {
                      this.showAlert(this.isEOZ ? `Select at least ${element.minnum} options for Question ${index + 1}.` : `第${index + 1}题请至少选择${element.minnum}项哦~`);
                      return false;
                  }
                  if(matchedItems.length > parseInt(element.maxnum)) {
                      this.showAlert(this.isEOZ ? `Select up to ${element.maxnum} options for Question ${index + 1}.` : `第${index + 1}题请至多选择${element.maxnum}项哦~`);
                      return false;
                  }
                  for (let j = 0; j < matchedItems.length; j++) {
                      const ele = matchedItems[j];
                      // 其他项必填且未填时，校验失败
                      if(ele.remark == 1 &&
                          ele.content_required == 1 &&
                          !ele.text
                      ) {
                          this.showAlert(this.isEOZ ? `Please complete Question ${index + 1}.` : `请填写第${index + 1}题的选项哦~`);
                          return false;
                      }
                  }
              }
          } else if(/^6/.test(element.qtype)) {
              //TODO:
          } else {
              if(element.required == 1 && !element.content) {
                  this.showAlert(this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`);
                  return false;
              }
              if((element.qtype == 3 || element.qtype == 307) &&
                parseInt(element.alength) > 0 &&
                element.content &&
                this.getCharLength(element.content) > parseInt(element.alength)
              ) {
                  this.showAlert(this.isEOZ ? `Your response to Question ${index + 1} exceeds the character limit.` : `第${index + 1}题超过字数限制哦`);
                  return false;
              }
          }
        }
        return true;
      },
      getCharLength(str) {
        //获得字符串实际长度，中文2，英文1
        //要获得长度的字符串
        var realLength = 0, len = str.length, charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128)
            realLength += 1;
            else
            realLength += 2;
        }
        return realLength;
      },
      submit() {
        if(this.isLoading) {
          return;
        }
        if(this.oldLogics.length && !this.logics.length) {
          this.showAlert(this.isEOZ ? 'This survey configuration has expired. Please contact the administrator.' : '该问卷配置已过期，请联系管理员~');
          return;
        }
        if(!this.checkForm()) {
            return;
        }
        let data = [];
        this.questions.forEach((x) => {
          if(/^[1|4|5]/.test(x.qtype)) {
            let matchedItem = x.options.find(item => item.selected);
            if(matchedItem) {
              data.push({
                qid: x.qid, oid: matchedItem.oid, content: matchedItem.remark == 1 ? matchedItem.text : matchedItem.content
              });
            }
          } else if (/^2/.test(x.qtype)) {
            let matchedItems = x.options.filter(item => item.selected);
            matchedItems.forEach(item => {
              data.push({
                qid: x.qid, oid: item.oid, content: item.remark == 1 ? item.text : item.content
              });
            });
          } else if (/^6/.test(x.qtype))  {
            x.rows.forEach(item => {
              if(item.val >= 0) {
                data.push({
                  qid: x.qid,
                  rid: item.rid,
                  oid: x.options[item.val].oid
                });
              }
            })
          } else {
            data.push({
              qid: x.qid,
              content: x.content
            });
          }
        });
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(window.navigator.userAgent);
        if(device.device && device.device.model === 'LIO-AN00') {
            device.device.model = 'Mate 30 Pro(5G)'
        }
        this.isLoading = true;
        api.submit({
          sid: this.$route.params.sid,
          answers: data,
          starttime: this.starttime,
          clientinfo: JSON.stringify(device)
        }).then(res => {
          this.isLoading = false;
          if(res) {
            this.submitted = true;
            this.showAlert(this.base.endmsg).then(() => {
                if(res.redirecturl) {
                    location.href = res.redirecturl;
                }
                if(res.callbackmsg) {
                    redirectTo(res.callbackmsg)
                }
            });
            console.log("surveyfinish"); // 不能删除，客户端会监听console.log
            if(this.isEOZ) {
              window.fbq && window.fbq('track', 'CompleteRegistration');
              // 如果所有题目都回答完，包括非必填的
              if(this.finished === this.questionNum) {
                window.fbq && window.fbq('track', 'Lead');
              }
            }
          }
        }).catch(() => {
          this.isLoading = false;
        });
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus">
@import '../../assets/stylus/minixs/_center.styl';
    .pg-answer-site
        width 100% !important
        min-height 100vh
        height 100%
        background-color #e0edfe
        background-image url('./images/bg.png')
        background-size contain
        background-repeat no-repeat
        background-position top center
        padding 95px 0 100px
        color: #484848;
        .container
            position relative
            width 1000px
            margin 0 auto
            height 100%
            min-height calc(100vh - 95px)
            border-radius: 18px;
            .submit {
                position: relative;
                display: block;
                width: 220px;
                height: 40px;
                margin: 80px auto 0;
                text-align: center;
                font-size: 16px;
                border-radius: 3px;
                background-color: #018fff;
                color: #fff;
                cursor: pointer;
            }
            .progress {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                padding: 14px 16px;
                &.fixed {
                    position: fixed;
                    box-shadow: 0 2px 1px rgba(0, 0, 0, 0.1);
                    z-index: 15;
                    background-color: #fff;
                    width: 1000px;
                    margin: 0 auto;
                }
                &-bar {
                    position: relative;
                    height: 6px;
                    background-color: #ebf3fd;
                    border-radius: 3px;
                }
                &-done {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    background-color: #018fff;
                    transition: all 0.3s;
                    border-radius: 3px;
                }
            }
            .survey_cover_text
                margin: 0 72px;
                padding: 30px 0 12px;
                background-color: transparent;
                box-shadow: none;
                .TopBgTitle
                    text-align: center;
                    margin-top: 40px;
                    font-size: 30px;
                .desc_begin
                    font-size: 16px;
                    line-height 1.5
                    margin: 40px 0 0;
                .wjhr
                    background-color: #53a4f4!important;
                    width: 100%;
                    height: 3px;
                    margin-top: 20px;
                .user {
                    float right
                    margin-top  20px
                    font-size 16px
                    .username {
                        margin-right 10px
                    }
                    i {
                      cursor pointer
                      &:hover {
                        color red
                      }
                    }
                }
            .questions
                width 100%
                padding 0 72px
                display flex
                flex-direction column
                justify-content center
            .submmit
                position: relative;
                display: block;
                width: 220px;
                height: 40px;
                line-height: 40px;
                margin: 80px auto 0;
                text-align: center;
                border-radius: 3px;
                background-color: rgb(35,120,255);
                color: #fff;
                cursor: pointer;
                font-size: 16px;
                &:hover
                    filter brightness(0.9)
            .tail
                height 84px;
                width 100%
</style>
